import { createElement, PropsWithChildren } from 'react';
import { StyledCard } from './styles';
import { TCardProps } from './types';
import cx from 'classnames';
import { applyModifiers } from 'src/utils/helpers';

export default function Card({ className, modifiers, ...props }: PropsWithChildren<TCardProps>) {
  return createElement(StyledCard, {
    ...props,
    className: cx(className, applyModifiers('card', undefined, modifiers)),
  });
}
